"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resources = void 0;
//@ts-ignore
const ru_common_json_1 = __importDefault(require("../../../configs/locale/ru.common.json"));
//@ts-ignore
const ru_errors_json_1 = __importDefault(require("../../../configs/locale/ru.errors.json"));
//@ts-ignore
const en_common_json_1 = __importDefault(require("../../../configs/locale/en.common.json"));
//@ts-ignore
const en_errors_json_1 = __importDefault(require("../../../configs/locale/en.errors.json"));
const useLocalStorage_1 = require("../../hooks/useLocalStorage");
const ru = Object.assign(Object.assign({}, ru_common_json_1.default), ru_errors_json_1.default.errors);
const en = Object.assign(Object.assign({}, en_common_json_1.default), en_errors_json_1.default.errors);
exports.resources = {
    ru,
    en,
};
class i18n {
    constructor(dict = exports.resources) {
        console.log("[i18n.constructor]");
        this.lang = (0, useLocalStorage_1.useLocalStorage)("language"); //default
        this.locales = dict;
    }
    language(lang) {
        if (lang && this.locales[lang]) {
            this.lang = lang;
        }
        return this.lang;
    }
    // defineLocale(name: Languages, values) {
    // 	console.log('[i18n.defineLocale]');
    // 	if (values !== null) {
    // 		this.locales[name] = values;
    // 		return this.locales[name];
    // 	} else {
    // 		delete this.locales[name];
    // 		return null;
    // 	}
    // }
    replace(word, params) {
        let result = word;
        for (let i = 1; i <= params.length; i++) {
            result = result.replace("[_" + i + "]", params[i - 1]);
        }
        return result;
    }
    t(word, params = null) {
        const wordOfDict = exports.resources[this.lang][String(word)];
        let result = wordOfDict || this.locales["ru"][word];
        if (params && params.length > 0 && typeof result === "string") {
            result = this.replace(result, params);
        }
        return result ? result : word;
    }
}
// Commented untill we can use types in dict
// type Word = typeof resources[Languages];
exports.default = new i18n();
